import React from 'react';
export function TomosSecundaria() {
  return <section className="py-16 px-6 bg-gray-50" data-id="element-244">
      <div className="max-w-4xl mx-auto" data-id="element-245">
        <div className="text-center mb-10" data-id="element-246">
          <h2 className="text-3xl font-extrabold text-gray-900" data-id="element-247">
            SECUNDARIA — 6 TOMOS
          </h2>
          <p className="text-gray-500 mt-2" data-id="element-248">
            Para docentes de inglés de 1° a 6° año
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-6" data-id="element-249">
          {[{
          num: '7',
          title: 'Tomo 7 — 1° Secundaria',
          sub: 'The Bridge: Level Up',
          desc: 'Past Continuous, Present Perfect con FOR/SINCE, modales y cláusulas relativas.',
          level: 'A2'
        }, {
          num: '8',
          title: 'Tomo 8 — 2° Secundaria',
          sub: 'Expressing Myself',
          desc: 'Past Perfect, condicionales completos, gerundios, registro formal e informal.',
          level: 'A2+'
        }, {
          num: '9',
          title: 'Tomo 9 — 3° Secundaria',
          sub: 'Think & Argue',
          desc: 'Formas de futuro, lenguaje de especulación, ensayo argumentativo y vocabulario académico.',
          level: 'B1'
        }, {
          num: '10',
          title: 'Tomo 10 — 4° Secundaria',
          sub: 'Social Impact',
          desc: 'Pasiva avanzada, discourse markers, carta formal, vocabulario de temas sociales.',
          level: 'B1'
        }, {
          num: '11',
          title: 'Tomo 11 — 5° Secundaria',
          sub: 'Global Perspectives',
          desc: 'Modales de deducción, estructuras avanzadas, ensayo discursivo y síntesis de textos.',
          level: 'B1+'
        }, {
          num: '12',
          title: 'Tomo 12 — 6° Secundaria',
          sub: 'Life After School',
          desc: 'CV, carta de presentación, personal statement, ensayo académico y preparación Cambridge B2.',
          level: 'B2'
        }].map(t => <div key={t.num} className="border border-gray-200 rounded-2xl p-5 flex gap-4 hover:shadow-md transition bg-white" data-id="element-250">
              <div className="w-10 h-10 bg-blue-700 text-white rounded-full flex items-center justify-center font-bold text-sm shrink-0" data-id="element-251">
                {t.num}
              </div>
              <div data-id="element-252">
                <p className="font-bold text-gray-900 text-sm" data-id="element-253">{t.title}</p>
                <p className="text-blue-700 text-xs font-semibold mb-1" data-id="element-254">
                  {t.sub}
                </p>
                <p className="text-gray-500 text-xs" data-id="element-255">{t.desc}</p>
                <span className="inline-block mt-2 bg-blue-50 text-blue-800 text-xs font-semibold px-2 py-0.5 rounded-full" data-id="element-256">
                  Nivel {t.level}
                </span>
              </div>
            </div>)}
        </div>

        {/* LO QUE INCLUYE CADA TOMO */}
        <div className="mt-12 bg-blue-600 text-white rounded-2xl p-8" data-id="element-257">
          <h3 className="text-xl font-bold mb-6 text-center" data-id="element-258">
            Cada tomo incluye:
          </h3>
          <div className="grid md:grid-cols-2 gap-3" data-id="element-259">
            {['15 actividades listas para imprimir y entregar', 'Consignas en inglés que el alumno entiende solo', "Guía docente 'salvavidas' en español", 'Solucionario para corrección rápida', 'Diseño en blanco y negro optimizado para fotocopiadora', 'Alineado al currículo argentino 2026'].map(item => <div key={item} className="flex items-center gap-2 text-sm" data-id="element-260">
                <span className="text-green-300 font-bold" data-id="element-261">✓</span>
                <span data-id="element-262">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}